/**
 * EVI-1957: When ON, chat source control cannot disable the last Evidence source
 * (disabled toggle + tooltip) and silent clinical-web force-on is skipped.
 *
 * Shipped at 100% Flagsmith, including managed users. The getter is hardcoded
 * true; the key stays declared and the console flag stays enabled.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the hook
 * does not add a `react-refresh/only-export-components` warning to the component
 * barrel. Import from `@/features/flags/evidence-chat-require-at-least-one-source`.
 *
 * Sync non-React reads: `IS_EVIDENCE_CHAT_REQUIRE_AT_LEAST_ONE_SOURCE_ENABLED`
 * in `legacy-flags.ts`.
 */
export const EVIDENCE_CHAT_REQUIRE_AT_LEAST_ONE_SOURCE_FLAG_KEY =
  'release-evidence-chat-require-at-least-one-source';

/** Shipped 100% — Flagsmith stays enabled. Console flag is not removed. */
export const useIsEvidenceChatRequireAtLeastOneSourceEnabled = () => true;
